import { get as _get } from 'lodash-es';
import { Fragment } from 'react';
import { useQuery } from '@apollo/client/react';
import Typography from '@mui/material/Typography';
import Loading from '../loading';
import ErrorMessage from '../error-message';
import NotFound from '../not-found';
import AttendeesList from './attendees-list';
import { eventAttendeesQuery } from '../../apollo/events';
import type { Event } from '../../types/Event';

type Props = {
  event: Event;
};

const EventAttendeesTab = ({ event }: Props) => {
  const { data, loading, error } = useQuery(eventAttendeesQuery, {
    variables: {
      id: event.id,
    },
  });
  const attendeesEvent = _get(data, 'event');

  if (error) {
    return <ErrorMessage message='An error occurred while loading attendees.' error={error} compact />;
  }
  if (loading) { return <Loading compact />; }
  if (!attendeesEvent) { return <NotFound compact />; }

  return (
    <Fragment>
      <Typography variant="h2">Attendees</Typography>
      <AttendeesList members={attendeesEvent.members} event={attendeesEvent} />
    </Fragment>
  );
};

export default EventAttendeesTab;
